<template lang="pug">
.deal-availability
  BriqToggleSwitch.mb-S(
    label="This deal is available in a specific period"
    name="dealAvailableInSpecificPeriod"
    v-model="showEditor"
    data-test-id="deal-availability-in-period-toggle"
    )
  transition(name="slide")
    div(v-show="showEditor")
      AvailabilityDateRange(
        label="This deal is available in a specific date range"
        :deal="deal"
        :hideOptionalMarker="true"
        )
      AvailableWeekdayTimes(
        label="This deal is available in a specific day and/or time"
        :deal="deal"
        :hideOptionalMarker="true"
        )
</template>

<script>
import AvailabilityDateRange from './DealAvailability/AvailabilityDateRange.vue'
import AvailableWeekdayTimes from './DealAvailability/AvailableWeekdayTimes.vue'
import { keys } from 'ramda'

export default {
  name: 'DealAvailability',
  components: { AvailabilityDateRange, AvailableWeekdayTimes },
  props: {
    deal: { type: Object, required: true },
  },
  data() {
    return {
      showEditor: false,
      availabilityMemory: {
        startDate: this.deal.AvailabilityStartDate,
        endDate: this.deal.AvailabilityEndDate,
        weekdayTimes: this.deal.AvailableWeekdayTimes,
      },
    }
  },
  computed: {
    availableWeekdayTimesExist() {
      return keys(this.deal.AvailableWeekdayTimes).length > 0
    },
  },
  mounted() {
    this.showEditor =
      !!this.deal?.AvailabilityStartDate ||
      !!this.deal?.AvailabilityEndDate ||
      !!this.deal?.AvailableWeekdayTimes
  },
  watch: {
    showEditor(newVal) {
      if (!newVal) {
        this.availabilityMemory.startDate = this.deal.AvailabilityStartDate
        this.availabilityMemory.endDate = this.deal.AvailabilityEndDate
        this.availabilityMemory.weekdayTimes = this.deal.AvailableWeekdayTimes
        this.deal.AvailabilityStartDate = null
        this.deal.AvailabilityEndDate = null
        this.deal.AvailableWeekdayTimes = null
      } else {
        this.deal.AvailabilityStartDate = this.availabilityMemory.startDate
        this.deal.AvailabilityEndDate = this.availabilityMemory.endDate
        this.deal.AvailableWeekdayTimes = this.availabilityMemory.weekdayTimes
      }
    },
  },
}
</script>

<style scoped lang="stylus">
$transitionEnter = 0.3s ease-in
$transitionLeave = 0.3s cubic-bezier(0, 1, 0.5, 1)

.slide-enter-active
  -moz-transition $transition
  -webkit-transition $transition
  -o-transition $transition
  transition $transition

.slide-leave-active
  -moz-transition: $transitionLeave
  -webkit-transition: $transitionLeave
  -o-transition: $transitionLeave
  transition: $transitionLeave

.slide-enter-to, .slide-leave
  max-height 100px
  overflow hidden

.slide-enter, .slide-leave-to
  overflow hidden
  max-height 0
</style>
